// Contact form, ported from the inline script in site-v4/contact.html.
// ?type= picks the enquiry type, ?subject= fills the subject line. The form
// posts to Shopify in the background (site.js postShopifyForm) and glides to
// the thank-you view; if Shopify can't confirm, it posts normally instead.
(function () {
  function init() {
    const form = document.getElementById('contact-form');
    if (!form || form.dataset.wired) return;
    form.dataset.wired = '1';
    const params = new URLSearchParams(window.location.search);
    const select = document.getElementById('enquiry-type');
    const label = document.getElementById('enquiry-type-label');
    const type = params.get('type');
    if (type && select && Array.from(select.options).some(o => o.value === type)) {
      select.value = type;
    }
    const subject = params.get('subject');
    if (subject) {
      const subjectField = document.getElementById('enquiry-subject');
      if (subjectField) subjectField.value = subject;
    }
    // The email to Maria shows the enquiry type as it reads on the page
    function syncLabel() { if (select && label) label.value = select.value ? select.options[select.selectedIndex].text : ''; }
    if (select) select.addEventListener('change', syncLabel);
    syncLabel();

    wireShopifyForm(form, 'contact_posted', function () { syncLabel(); }, function () {
      const block = document.getElementById('contact-form-block');
      const success = document.getElementById('contact-form-success');
      glide(block ? block.parentNode : null, function () {
        if (block) block.style.display = 'none';
        if (success) success.style.display = 'block';
      });
      if (success) success.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('mg:section-load', init);
})();
